var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lucre-geotap-logo"},[(_vm.heading == 'h1')?_c('h1',{staticClass:"heading"},[_vm._v("GEOTAP  ")]):_vm._e(),(_vm.heading == 'h4')?_c('h4',{staticClass:"heading"},[_vm._v("GEOTAP  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c8fdffc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GeotapLogo.vue
// module id = DRzB
// module chunks = 0